export default __webpack_public_path__ + "static/media/mbmi-grey.6a40bf7c.png";